import { createSelector } from 'reselect';
import { extractGuid } from '@/utils';
import currentSessionSelector from './currentSession';

export default createSelector(
  currentSessionSelector,
  sessionId => extractGuid(sessionId)
);



// WEBPACK FOOTER //
// ./src/selectors/ownerGuid.js